import { TranslateResult } from 'vue-i18n'
import { NewsUrl, siteBroadcasterUrl } from './urls'
import { DjangoUrl } from './dashboard'

export interface Feature {
  title: string | TranslateResult
  body?: string | TranslateResult
  link?: string | Array<{ slug: TranslateResult; url: string }>
  secondText?: string | TranslateResult
  icon?: string
  image?: string
}

export const loopingVaultSermonID = 717251954565706
export const topVideoID = 73025333477169
export const promoVideoID = 73125161435437

export function WhyChooseSermonAudio(vue: Vue): Feature[] {
  return [
    {
      title: vue.$t('Unlimited Sermons'),
      body: vue.$t(
        'Upload your entire library of sermons in both audio and video without limits to a secure platform purpose-built for sermons.'
      ),
      link: NewsUrl('sermon-dashboard'),
      image: 'broadcaster/overview/abstract_sermons.webp',
    },
    {
      title: vue.$t('Live Webcasting'),
      body: vue.$t(
        'Enjoy our robust, fully-featured live streaming system—with no additional fees and full support for multicasting to additional platforms.'
      ),
      link: NewsUrl('live-webcasting'),
      image: 'broadcaster/overview/abstract_webcasts.png',
    },
    {
      title: vue.$t('Device Support'),
      body: vue.$t(
        'Enjoy full native app support across a wide range of devices—so you can access sermons and webcasts anytime, anywhere.'
      ),
      link: '/devices',
      image: 'broadcaster/overview/abstract_devices.png',
    },
  ]
}
export function MainFeatures(vue: Vue): Feature[] {
  return [
    {
      title: vue.$t('Global Sermons'),
      body: vue.$t(
        'We make it easy to take any sermon preached in English and have it re-preached in multiple languages using the best AI technologies.**'
      ),
      icon: 'globe',
      secondText: vue.$t('Coming Soon!'),
    },
    {
      title: vue.$t('Sermon Transcripts'),
      body: vue.$t(
        'Enable automatic, accurate, and private sermon transcriptions—powered by Vault AI and enjoy fully searchable sermons.'
      ),
      icon: 'transcript',
      link: NewsUrl('transcribe-everything'),
    },
    {
      title: vue.$t('Church Finder'),
      body: vue.$t(
        'Get listed in our Local Church Finder to increase your visibility and help your local community discover your church.'
      ),
      icon: 'map-marked',
      link: DjangoUrl('/churchfinder'),
    },
    {
      title: vue.$t('Multicasting'),
      body: vue.$t(
        'Multicasting sends your live stream to SermonAudio and restreams it to platforms like Facebook or YouTube—at no extra cost.'
      ),
      icon: 'broadcast',
      link: NewsUrl('multicast'),
    },
    {
      title: vue.$t('Cross Publishing'),
      body: vue.$t(
        'Optionally upload full-length sermons to Facebook and YouTube with a single click and spread your net even wider!'
      ),
      icon: 'share',
      link: NewsUrl('cross-publish'),
    },
    {
      title: vue.$t('Podcasting'),
      body: vue.$t(
        'Every broadcaster enjoys full, native support for audio and video podcasts with customizable artwork and landing pages.'
      ),
      icon: 'podcast',
      link: NewsUrl('series-podcasting'),
    },
    {
      title: vue.$t('Standalone Site and App'),
      body: vue.$t(
        `Whether it's a website or a native mobile app, every broadcaster enjoys a standalone solution with only your content appearing.`
      ),
      icon: 'window',
      link: [
        { slug: 'Solo Sites', url: NewsUrl('solo-sites') },
        { slug: 'ChurchOne', url: NewsUrl('churchone') },
      ],
    },
    {
      title: vue.$t('Articles Support'),
      body: vue.$t(
        'A simple and effective way for broadcasters to write, publish, and share written content such as devotionals, blogs, and announcements.'
      ),
      icon: 'paragraph',
      link: NewsUrl('articles'),
    },
    {
      title: vue.$t('Vault AI'),
      body: vue.$t(
        'Integration of powerful AI models in The Vault. Everything great about AI, without the risks: secure, private, and under our control.'
      ),
      icon: 'vault-ai',
      link: NewsUrl('vaultai'),
    },
  ]
}
export function ExtraFeatures(vue: Vue): Feature[] {
  return [
    { title: vue.$t('Smart TV Support'), link: NewsUrl('tv') },
    { title: vue.$t('Smart Speaker Support'), link: NewsUrl('echo') },
    {
      title: vue.$t('Roku TV Support'),
      link: NewsUrl('roku-tv'),
    },
    {
      title: vue.$t('Private Webcasts'),
      link: NewsUrl('live-webcasting'),
    },
    {
      title: vue.$t('Online Donation Integration'),
      link: NewsUrl('donations'),
    },
    { title: vue.$t('Listen Line'), link: NewsUrl('listen-line') },
    { title: vue.$t('Analytics'), link: NewsUrl('sermon-play') },
    { title: vue.$t('Promotional Tools'), link: NewsUrl('promote') },
    { title: vue.$t('Embed Editor'), link: NewsUrl('embed') },
    { title: vue.$t('Batch Uploads via FTP'), link: NewsUrl('ftp') },
    {
      title: vue.$t('Batch Uploads via RSS'),
      link: NewsUrl('automated-uploads'),
    },
    {
      title: vue.$t('Batch Uploads via Dropbox'),
      link: NewsUrl('dropbox'),
    },
    {
      title: vue.$t('Directory of Vacant Pulpits'),
      link: NewsUrl('vacant-pulpits'),
    },
    {
      title: vue.$t('Learn Tutorials'),
      link: siteBroadcasterUrl('learn'),
    },
    {
      title: vue.$t('Vault Shield'),
      link: NewsUrl('shield'),
    },
    {
      title: vue.$t('Programming API'),
      link: NewsUrl('api'),
    },
    {
      title: vue.$t('Bible Partnership Logos'),
      link: NewsUrl('logos-software'),
    },
    {
      title: vue.$t('Bible Partnership BLB'),
      link: NewsUrl('blb'),
    },
    {
      title: vue.$t('Bible Partnership Biblearc'),
      link: NewsUrl('biblearc'),
    },
    {
      title: vue.$t('Bible Partnership e-Sword'),
      link: NewsUrl('e-sword-software'),
    },
  ]
}
